import { render, staticRenderFns } from "./DashboardMenu.vue?vue&type=template&id=5cfd673e&scoped=true&"
import script from "./DashboardMenu.vue?vue&type=script&lang=js&"
export * from "./DashboardMenu.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMenu.vue?vue&type=style&index=0&id=5cfd673e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfd673e",
  null
  
)

/* custom blocks */
import block0 from "./DashboardMenu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports